(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('OffTimeSearch', OffTimeSearch);

    OffTimeSearch.$inject = ['$resource', 'ENV'];

    function OffTimeSearch($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/_search/off-times/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
